import { ModuleInfo } from "../module-info.model";

export class ModuleManagerTransferData {
    moduleID: number;
    moduleKey: string;
    childModule: string;
    moduleInfo: ModuleInfo;
    states: { [stateName: string]: any };
    settings: { [settingName: string]: any };
    childObject: any;
}